import {useEffect} from 'react';
import {Title} from '../../../components/layout/title';

export const Document = {
  Title,
  Description: ({children}) => {
    useEffect(() => {
      document.querySelector('meta[name="description"]').setAttribute('content', children);
    }, []);
    return null;
  }
};
